/* El descuento de un link (?desc=CODIGO) o de un codigo escrito vive en sessionStorage, que sobrevive a recargar la pagina
   (incluso con Ctrl+Shift+R, que solo limpia la cache de archivos). Para que recargar lo reinicie:
   - al CARGAR la pagina (no al navegar dentro de ella) se borra si la direccion ya no trae ?desc=;
   - al aplicar el del link se quita ?desc= de la direccion, asi recargar no lo vuelve a aplicar.
   El descuento que elige a mano un vendedor (descuentoVentaSel con id) no se toca. */

const tieneDescuentoEnLaDireccion = (loc) => !!new URLSearchParams(loc.search).get("desc")

export const reiniciarDescuentoAlCargar = (loc = window.location, storage = window.sessionStorage) => {
  try {
    if (tieneDescuentoEnLaDireccion(loc)) return;
    storage.removeItem("descuentoLinkPublico");
    const sel = JSON.parse(storage.getItem("descuentoVentaSel") || "null");
    if (sel && sel.codigo && !sel.id) storage.removeItem("descuentoVentaSel");
  } catch (_e) { /* sin sessionStorage: no hay nada que reiniciar */ }
};

export const quitarDescuentoDeLaDireccion = (loc = window.location, historial = window.history) => {
  try {
    const url = new URL(loc.href);
    if (!url.searchParams.has("desc")) return;
    url.searchParams.delete("desc");
    historial.replaceState(historial.state, "", `${url.pathname}${url.search}${url.hash}`);
  } catch (_e) { /* la direccion se queda como estaba */ }
};
